<template>
  <el-row>
    <textarea v-if="multiline"
      class="el-textarea__inner"
      :value="text"
      :rows="rows"
      :placeholder="placeholder"
      @input="inputChanged"
    >
    </textarea>
    <input v-else
      type="text"
      :value="text"
      :placeholder="placeholder"
      class="el-input__inner"
      @input="inputChanged"
    >
    <span
      v-if="(limitLength > 0)"
      :class="[ (overlength) ? 'input-counter-error': 'input-counter' ]"
    >
      {{ textLength }} / {{ limitLength }}
    </span>
  </el-row>
</template>

<script>
export default {
  name: 'InputText',
  model: {
    prop: 'text',
    event: 'change'
  },
  props: {
    text: {
      type: String
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiline: {
      type: Boolean,
      default: false
    },
    limitLength: {
      type: Number,
      default: 0
    },
    rows: {
      type: Number,
      default: 0
    }
  },
  computed: {
    textLength: function () {
      var result = 0
      for (var i = 0; i < this.text.length; i++) {
        var chr = this.text.charCodeAt(i)
        if ((chr >= 0x00 && chr < 0x81) ||
            (chr === 0xf8f0) ||
            (chr >= 0xff61 && chr < 0xffa0) ||
            (chr >= 0xf8f1 && chr < 0xf8f4)) {
          // 半角文字の場合は1を加算
          result += 1
        } else {
          // それ以外の文字の場合は2を加算
          result += 2
        }
      }
      // 結果を返す
      return result
    },
    overlength: function () {
      return (this.textLength > this.limitLength)
    }
  },
  methods: {
    inputChanged: function (e) {
      this.$emit('change', e.target.value)
    }
  }
}
</script>

<style scoped>
span.input-counter {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: small;
  color: gray;
}
span.input-counter-error {
  position: absolute;
  bottom: 5px;
  right: 10px;
  font-size: small;
  color: red;
}
</style>
